import { render, staticRenderFns } from "./site-menu-submenu.vue?vue&type=template&id=c0377a0a&scoped=true&"
import script from "./site-menu-submenu.vue?vue&type=script&lang=js&"
export * from "./site-menu-submenu.vue?vue&type=script&lang=js&"
import style0 from "./site-menu-submenu.vue?vue&type=style&index=0&id=c0377a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0377a0a",
  null
  
)

export default component.exports